import {Injectable, NgZone} from '@angular/core';
import {Observable, Subscriber} from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class SseService {
	private eventSource?: EventSource;

	constructor(private zone: NgZone) {
	}

	getEventSource(url: string, options: EventSourceInit): EventSource {
		return new EventSource(url, options);
	}

	connectToServerSentEvents(url: string, options: EventSourceInit, eventNames: string[] = []): Observable<Event> {
		// this.close(); // close previous connection if exists

		const es = this.getEventSource(url, options);
		this.eventSource = es;

		return new Observable((subscriber: Subscriber<Event>) => {
			const listeners: Array<{ event: string; handler: EventListener }> = [];

			es.onerror = (error) => {
				this.zone.run(() => subscriber.error(error));
			};

			eventNames.forEach((event: string) => {
				const handler: EventListener = (data) => {
					this.zone.run(() => subscriber.next(data as Event));
				};
				listeners.push({event, handler});
				es.addEventListener(event, handler);
			});

			return () => {
				listeners.forEach(({event, handler}) => es.removeEventListener(event, handler));
				es.close();
				if (this.eventSource === es) this.eventSource = undefined;
			};
		});
	}

	close(): void {
		if (this.eventSource) {
			this.eventSource.close();
			this.eventSource = undefined;
		}
	}
}
